module.exports = __webpack_public_path__ + "static/media/ui_def-yes.82afcc1b.svg";